import React, { memo, useEffect, useState } from "react";
import CryptoHuntTimer from "./CryptoHuntTimer";
import CryptoHuntAttemptsCard from "./CryptoHuntAttemptsCard";
import { toast } from "react-toastify";
import ButtonCard from "./ButtonCard";

const CryptoHuntGameWrapper = ({
  letterFeedback,
  guessResponse,
  isActive,
  time,
  attemptsLeft,
  handleChange,
  userInput,
  inputRef,
  handleKeyPress,
  isWordCompleted,
  prevWords,
  isWin,
  dailyLeft,
}) => {
  useEffect(() => {
    if (isActive && inputRef.current.length > 0 && !guessResponse?.isLoading) {
      inputRef.current[0]?.focus();
    }
  }, [isActive, inputRef, isWin, prevWords, guessResponse?.isLoading]);

  const getBackgroundColor = (feedbackItem) => {
    if (feedbackItem?.correct && feedbackItem?.position) return "bg-green-500";
    if (feedbackItem?.correct && !feedbackItem?.position)
      return "bg-yellow-500";
    return "bg-gray-500";
  };

  const handleBackspace = (index, e) => {
    if (e.key === "Backspace" && userInput[index] === "" && index > 0) {
      e.preventDefault();
      inputRef.current[index - 1]?.focus();
    }
  };

  return (
    <>
      {isActive ? (
        <div
          onKeyDown={handleKeyPress}
          className="w-full pb-7 flex flex-col items-center 2xl:gap-y-8 gap-y-6"
        >
          <h1 className="xl:text-[36px] md:text-3xl sm:text-2xl xs:text-xl text-base font-bold font-redHat">
            Hunt(Guess ) the token
          </h1>
          <div className="flex flex-col gap-y-4 items-center">
            <ButtonCard
              module="crypto-hunt"
              text={"Daily Left"}
              className={""}
              value={dailyLeft}
            />
            <CryptoHuntTimer time={time} />
            <CryptoHuntAttemptsCard attemptsLeft={attemptsLeft} />
          </div>
          <div className="w-full flex flex-col 2xl:gap-y-4 xs:gap-y-3 gap-y-2 items-center">
            {prevWords?.length !== 0 && (
              <>
                {prevWords?.map((word, wordIdx) => (
                  <div
                    key={wordIdx}
                    className="flex  2xl:space-x-3 xs:gap-x-2 gap-x-1"
                  >
                    {word?.split("")?.map((char, charIdx) => {
                      const feedbackItem = letterFeedback[wordIdx]?.[charIdx];
                      return (
                        <WordTile
                          key={charIdx}
                          char={char}
                          className={getBackgroundColor(feedbackItem)}
                        />
                      );
                    })}
                  </div>
                ))}
              </>
            )}
            {attemptsLeft > 0 &&
              time > 0 &&
              isWin === false &&
              !guessResponse?.isLoading && (
                <div className="flex pb-5 2xl:space-x-3 xs:gap-x-2 gap-x-1">
                  {userInput.map((char, index) => (
                    <input
                      key={index}
                      type="text"
                      value={char}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleBackspace(index, e)}
                      className={`${
                        userInput?.length > 6 && ""
                      } xl:h-20 sm:h-[72px] h-12 xl:w-20 sm:w-[72px] w-12 sm:text-2xl xs:text-xl text-base text-center bg-[#1e1e1e] uppercase text-xl font-bold border-[3px] border-[#434343] rounded-md  focus:outline-none`}
                      ref={(el) => {
                        return (inputRef.current[index] = el);
                      }}
                    />
                  ))}
                </div>
              )}

            {!!isWordCompleted && (
              <button className="text-[#eaeaea] text-xl font-bold">
                Press Enter
              </button>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CryptoHuntGameWrapper;

const WordTile = memo(({ char, className }) => {
  return (
    <div
      className={`${className} xl:h-20 sm:h-[72px] h-12 xl:w-20 sm:w-[72px] w-12 sm:text-2xl xs:text-xl text-base text-center flex justify-center items-center text-center uppercase font-bold rounded-md`}
      role="heading"
    >
      {char}
    </div>
  );
});
